import { completeName, i18n } from "../../utils";

export const normalizeDataPatients = (
  payload: any,
  serviceStateLookup: Record<string, string> = {},
  serviceTypeLookup: Record<string, string> = {},
) => {
  const data = payload.item?.items;
  return data.map((item: any) => ({
    id: item.id,
    name: completeName(item.firstName, item.middleName, item.lastName),
    serviceNumber: item.serviceNumber,
    principalAuxId: item.principalAuxId,
    secondaryAuxId: item.secondaryAuxId,
    serviceStateCode: item.serviceState.code ? (serviceStateLookup[item.serviceState.code] ?? item.serviceState.code) : '',
    serviceTypeCode: item.serviceType.code ? (serviceTypeLookup[item.serviceType.code] ?? item.serviceType.code) : '',
    access: i18n(item.access),
    group: item.group.code,
    actions: true,
  }));
};

export const normalizeDataDuplicatePatients = (payload: any) => {
  const data = payload.data?.item?.items;
  return data.map((item: any) => ({
    id: item.id,
    name: completeName(item.firstName, item.middleName, item.lastName),
    serviceNumber: item.serviceNumber,
    birthdate: item.birthdate,
    idDocument: item.idDocument,
    access: i18n(item.access),
    groupName: item.groupName,
  }));
};